import React, { useEffect, useState } from 'react';

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from '../componentes/Menu';
import dataSuper from "../hooks/Conf";
import dataDireccionEstudiantil from '../hooks/useDireccionEstudiantil';
import dataFinanzas from '../hooks/useFinzas';
import CarAlumnoDatos from '../element/CarAlumnoDatos';
import CarHorasSociales from '../element/CarHorasSociales';
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
// Contexto
// import dataContext from "../context/User";
// Helper 
import GetFetch from '../helper/GetFetch';
import loadMenu from '../js/main';
import Footer from '../componentes/Footer';

import '../css/styleAdmin.css';
// import { data } from 'jquery';

const AlumnosHorasSociales = () => {

    const history = useHistory();

    const [carnet, setCarnet] = useState({});
    const [horasSociales, setHorasSociales] = useState({});
    const [alumno, setAlumno] = useState({});
    const [solvencia, setSolvencia] = useState();
    const [cargando, setCargando] = useState(false);
    let ths = 0;

    // const dataUser = useContext(dataContext);
    let datos = localStorage.getItem('dataUser');

    if (!datos) {
        history.push("/");
    }

    datos = JSON.parse(datos);

    if (dataSuper.indexOf(datos.carnet.trim()) === -1) {
        if (dataDireccionEstudiantil.indexOf(datos.carnet.trim()) === -1 && dataFinanzas.indexOf(datos.carnet.trim()) === -1) {
          history.push("/");
        }
      }  

    let carnetSet = (e) => {
        setCarnet(e.target.value)
    }

    let onSutmit = (e) => {
        e.preventDefault();
        localStorage.setItem('currentCarnet', carnet);
        setCargando(true);
        let hs = GetFetch.horasSociales(carnet, datos.token);
        hs.then((dataHS) => {
            if (!dataHS.length <= 0) {
                document.getElementById('dataContenedorAlumno').style.display = 'block';
                setHorasSociales(dataHS);                
                AlumnoDatos();
            }else{
                setHorasSociales([]);
                document.getElementById('dataContenedorAlumno').style.display = 'block';
                AlumnoDatos();
                document.getElementById('ths').innerHTML = 0;
                if(localStorage.getItem('solvencia')){
                    setSolvencia('INSOLVENTE')
                    setTimeout(() => {
                      localStorage.removeItem('solvencia')
                    }, 5000);
                }
            }
            setCargando(false);
        }).catch(() => setCargando(false));
    }

    let AlumnoDatos = () => {
        let datosAlum = GetFetch.datosAlumno(carnet, datos.token);
        datosAlum.then((data) => {
            if (data[0]) {
                setAlumno(data[0]);                
            }
        });
    }

    useEffect(() => {
        let currentCarnet = localStorage.getItem('currentCarnet');
        if (currentCarnet) {
            setCarnet(currentCarnet);
        }else{
            setCarnet('');
        }
        loadMenu();
        document.getElementById('textCarnet').focus();
    }, []);

    return (
        <div className="wrapper d-flex align-items-stretch">
            <nav id="sidebar">
                <div className="custom-menu">
                    <button
                        type="button"
                        id="sidebarCollapse"
                        className="btn btn-primary"
                    >
                        <i className="fa fa-bars"></i>
                        <span className="sr-only">Toggle Menu</span>
                    </button>
                </div>
                <div className="p-4">
                    <Foto
                        foto={datos.carnet}
                        alt="Foto alumno"
                        tamanio="rounded" />

                    <HeaderMenu
                        carnet={datos.carnet}
                        nombre={datos.nombre}
                        perfil={datos.perfil}
                        carrera={datos.carrera}
                        posicion="text-center"
                    />

                    <Menu />

                    <Footer />
                </div>
            </nav>

            <div id="content" className="p-4 p-md-5 pt-5">
                <h2 className="mb-4">Horas sociales por alumno</h2>

                <div className="card mb-4">
                    <div className="card-body">
                        <form id='formUP' onSubmit={onSutmit}>
                            <div className="form-group">
                                <label htmlFor="textCarnet">Carnet del alumno</label>
                                <input id="textCarnet" type="text" placeholder="Carnet" className="form-control" onChange={carnetSet} value={carnet} />
                            </div>
                            <button type="submit" className="btn btn-primary">
                                <i className="fa fa-search mr-2" aria-hidden="true"></i>
                                Buscar
                            </button>
                        </form>
                    </div>
                </div>

                <CarAlumnoDatos
                    alumno={alumno}
                />

                <p className="text-right text-muted">
                    Total de horas sociales: <b id="ths"></b>
                </p>

                {cargando ? (
                    <SkeletonCard rows={4} />
                ) : horasSociales.length > 0 ? (
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Empresa</th>
                                            <th scope="col">Actividad</th>
                                            <th scope="col">Tipo de hora</th>
                                            <th scope="col">Desde</th>
                                            <th scope="col">Hasta</th>
                                            <th scope="col">Horas</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {horasSociales.map((element, i) => {
                                            ths += element.horas
                                            document.getElementById('ths').innerHTML = ths
                                            return (
                                                <CarHorasSociales
                                                    key={i}
                                                    datos={element}
                                                />
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                ) : solvencia ? (
                    <div className="alert alert-danger" role="alert">
                        <i className="fa fa-exclamation-circle mr-2" aria-hidden="true"></i>
                        <b>Alumno insolvente.</b> Debe regularizar sus pagos para poder consultar sus horas sociales.
                    </div>
                ) : (
                    <EmptyState icon="fa-search" title="Busca un alumno por carnet">
                        Ingresa el carnet del alumno y presiona Buscar para consultar sus horas sociales.
                    </EmptyState>
                )}
            </div>
        </div>
    )

}

export default AlumnosHorasSociales;